import { PieceAssetSize, PieceAssetType } from '@apiContract';
import { getUploadUrl } from 'src/api/piece';

import { ButtonConfig } from '@components/Capture/types';

const LARGE_DELIVERY_IMAGE_TYPE = {
  type: PieceAssetType.DeliveryImage,
  size: PieceAssetSize.Large,
};

export const getUploadParamsForImage = async (pieceId: number) => {
  const { pieceAssets } = await getUploadUrl(pieceId);

  const { url, key } =
    pieceAssets.find(
      (asset) =>
        asset.pieceAssetType === LARGE_DELIVERY_IMAGE_TYPE.type &&
        asset.pieceAssetSize === LARGE_DELIVERY_IMAGE_TYPE.size,
    ) || {};

  return { url, key };
};

export const getButtonConfigs = (onRetake: () => void, onComplete: () => void, loading: boolean): ButtonConfig[] => [
  {
    label: 'Retake',
    type: 'inherit',
    onClick: onRetake,
  },
  {
    label: 'Complete',
    type: 'primary',
    isLoading: loading,
    onClick: onComplete,
  },
];
